import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { InterventionKeywordPendingChecklist } from "models";

export const useAddInterventionPendingChecklistMutation = () =>
  useTypedMutation<InterventionKeywordPendingChecklist, void>({
    mutationFn: async payload => (await ApiInstance.post("/intervention_keywords_pending_checklists/create", payload, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const pendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.interventionPendingChecklists);
      if (!pendingChecklists) return;

      const pendingChecklistIdx = pendingChecklists.findIndex(
        p => p.checklist_id === payload.checklist_id && p.keyword === payload.keyword && p.vin_prefix === payload.vin_prefix
      );
      if (pendingChecklistIdx >= 0) return;

      typedQueryClient.setQueryData(PendingChecklistsQueryKeys.interventionPendingChecklists, [...pendingChecklists, payload]);
    }
  });
